import apiAxios from "@/config/apiAxios";
// import api from "@genesys/ui/common/api";
let docServiceUrl    = `${config.serverUrl}/cmss/v1/comp-service/user/resource`;
let docServiceUrlV1  = `${config.serverUrl}/cmnd/ndisk/ms/v1`



export default {

	/**
	 * 获取文件附属信息
	 * @param path
	 * @param response
	 * @returns {*}
	 */
	getFileInfoByPath( path, response ){
	    return apiAxios.get( `${docServiceUrlV1}/info/${path}`, {}, response );
	},

	/**
	 * 更新资源FileInfo信息
	 */
	updateFileInfo( path, responce ) {
		return apiAxios.patch( `${docServiceUrlV1}/info/${path}`, {}, response );
	},

	/**
	 * 获取当前目录下文件的fileinfo信息
	 * @param path
	 * @param response
	 * @returns {*}
	 */
	getFileInfoList( path, data, response ){
	    return apiAxios.post( `${docServiceUrlV1}/dir_list/${path}`, data, response );
	},

	/**
	 * 获取当前目录下文件的fileinfo信息（所有文件）
	 * @param path
	 * @param response
	 * @returns {*}
	 */
	getFileInfoListAll( path, data, response ){
	    return apiAxios.post( `${docServiceUrlV1}/dir_listall/${path}`, data, response );
	},

	/**
	 * 创建目录
	 * @param path
	 * @param dirName
	 * @param response
	 * @returns {*}
	 */
	createFolder( path, dirName, tagList, response ) {
	    let _param  = {
	        name : dirName,
	    };
	    if( tagList ){
	        let _tags   = [];
	        tagList.forEach( _t => {
	            _tags.push( { "op" : "add","path" : `/${_t}`, "value" : true } )
	        } )
	        _param["tags"] = JSON.stringify( _tags );
	    }
	    return apiAxios.post( `${docServiceUrlV1}/dir_create/${path}/`, _param, response );
	},

	/**
	 * 创建目录(多级创建)
	 * @param path
	 * @param dirName
	 * @param response
	 * @returns {*}
	 */
	createFolderS( path, dirName, response ) {
	    return apiAxios.post( `${docServiceUrlV1}/dirs_create/${path}`, {
			name : dirName,
		}, response );
	},

	/**
	* 重命名
	* @param path
	* @param name
	*/
   rename( path, name, response ){
	   return apiAxios.postRequestForm( `${docServiceUrlV1}/rename/${path}`, { name: name }, response );
   },

   /**
   * 修改资源信息
   * @param path
   * @param param
   * @param response
   */
   editFile( path, param, response ){
     return apiAxios.putRequestForm( `${docServiceUrlV1}/file_cover/${path}`, param, response );
   },

   /**
	* 复制文件\文件夹(不能重命名文件夹)
	* @param pathTo
	* @param pathFrom
	* @param name
	* @param rewrite
	*/
   copy( pathFrom, pathTo, name = false, rewrite = false, response ){
	   let _param  = { path : pathTo };
	   if( name )_param.name     = name;
	   _param.rewrite  = rewrite ? true : false;
	   return apiAxios.post( `${docServiceUrlV1}/copy/${pathFrom}`, _param, response )
   },

   /**
   	* 复制文件夹并重命名
   	* @param pathTo
   	* @param pathFrom
   	* @param name
   	* @param rewrite
   	*/
   copyFolderAndRename( pathFrom, pathTo, name, rewrite = false, response ){
   	   let _param  = {
		   path : pathTo,
		   name	: name,
		   label: name
		};
   	   return apiAxios.post( `${docServiceUrlV1}/dir_copy/${pathFrom}`, _param, response )
   },

	/**
	 * 移动
	 */
	move( pathFrom, pathTo, name= false, response ) {
		let _param = { path : pathTo }
		if( name ) _param.name = name;
		return apiAxios.post( `${docServiceUrlV1}/move/${pathFrom}`, _param, response )
	},

	/**
	 * 创建文件(上传)
	 * @param path
	 * @param dirName
	 * @param response
	 * @returns {*}
	 */
	createFile( path, dirName, param, response ){
		param.name	= dirName;
	    return apiAxios.postRequestForm( `${docServiceUrlV1}/file_create/${path}`, param, response );
	},

	/**
	 * 使用JSON创建文件
	 * @param path
	 * @param fileName
	 * @param jsonStr
	 */
	createJsonFile( path, fileName, jsonStr, params, response ){
		let _blob = new Blob( [JSON.stringify( jsonStr )], { type: "text/plain;charset=utf-8" } );
		let _file = new File( [_blob], fileName, { lastModified: Date.now() } );
		params.name		= fileName;
		params.content	= _file;

		return apiAxios.postRequestForm( `${docServiceUrlV1}/file_create/${path}`, params, response );
	},

	/**
	 * 下载资源
	 * @param path
	 * @returns {*}
	 */
	downloadByPath( path, fileName, response ){
	    return apiAxios.download( `${docServiceUrlV1}/file_download/${path}`, {}, fileName, response );
	},

	/**
	 * 获取文件内容
	 * @param path
	 * @param response
	 */
	getFileContextByPath( path, contextType, response, responseType ){
	    return apiAxios.get( `${docServiceUrlV1}/file_preview/${path}?contentType=${contextType}`, {}, response, null, null, responseType);
	},

	/**
	 * 获取回收站内文件列表
	 */
	getFileInfoListInRec(path, response) {
		return apiAxios.get( `${docServiceUrlV1}/dust_list/${path}`, {
			// filter: `('fileInfo.extends.resource.hiddenStatus' eq 1)`,
			// sort: "fileInfo.extends.resource.type desc, fileInfo.createTime desc" // 1.文件夹始终在前；2.按时间倒序；
		}, response);
	},

	/**
	 * 删除资源到回收站
	 * @param path
	 * @param response
	 * @returns {*}
	 */
	recResource( path, response ) {
	    return apiAxios.put( `${docServiceUrlV1}/dust_del/${path}`, {}, response );
	},

	/**
	 * 恢复回收站中的文件
	 * @param path
	 * @param response
	 */
	recoverResource( spaceId, id, response ){
	    return apiAxios.put( `${docServiceUrlV1}/dust_recovery/${spaceId}/${id}`, {}, response );
	},

	/**
	 * 彻底删除文件
	 * @param path
	 * @param response
	 * @returns {*}
	 */
	delResourceById( spaceId, id, response ){
	    return apiAxios.delete( `${docServiceUrlV1}/dust_remove/${spaceId}/${id}`, {}, response );
	},

	/**
	 * 标签列表
	 */
	getTagList( path, response ) {
		return apiAxios.get( `${docServiceUrlV1}/tag/${path}`, {}, response );
	},

	/**
	 * 添加标签
	 */
	addTag( path, params, response ) {
		return apiAxios.put( `${docServiceUrlV1}/tag/${path}`, params, response );
	},

	/**
	 * 删除标签
	 */
	delTag( path, params, response ) {
		return apiAxios.deleteBody( `${docServiceUrlV1}/tag/${path}`, params, response );
	},

	/**
	 * 删除全部标签
	 */
	delAllTag( path, response ) {
		return apiAxios.delete( `${docServiceUrlV1}/tags/${path}`, {}, response );
	},


	/**
	 * 操作日志
	 */
	getLogs( id, params, response ) {
		let _filter = `( source eq 'NDISK' ) AND ( 'message.id' eq '${id}' )`;
		let _tags	= ['QUERY_INFO','QUERY_TAG','QUERY_INFO_IN_SHARED_SPACE','QUERY_ALLLOGS_IN_SHARED_SPACE','QUERY_INFO_VERSION',
			'QUERY_INFO_IN_SHARED_SPACE','QUERY_TAG_IN_SHARED_SPACE','QUERY_INFO_IN_SHARED_SPACE_IN_SHARED_SPACE','QUERY_ALLLOGS_IN_SHARED_SPACE','QUERY_INFO_VERSION_IN_SHARED_SPACE'];
		Object.keys( _tags ).forEach( _k => {
			_filter += ` AND ( 'deal_stage' ne '${_tags[_k]}' )`
		} )

		Object.keys( params ).forEach( _k => {
			_filter += ` AND ( '${_k}' eq '${params[_k]}' )`
		} )

		let _params = {
			url     : `${config.serverUrl}/cmbs/v1/jump/thdb/cmdp/user_behavior?filter=${_filter}&sort=deal_time desc&limit=1000`,
			method  : "GET",
			body    : {},
			header  : {},
			files   : [],
		}
		apiAxios.post(  `${config.serverUrl}/cmss/v1/comp-service/api/send`, _params, _r => {

			response( _r )
		} )
	},

	/**
	 * 获取历史版本
	 */
	getInfoVersion(path, response) {
		return apiAxios.get( `${docServiceUrlV1}/infoVersion/${path}`, {}, response );
	},

	/**
	 * 查看最近查看的文件
	 */
	getRecentList( ) {

		 return	new Promise( (resolve, reject ) => {
			apiAxios.get( `${docServiceUrlV1}/recent_list`, {}, _r => {
				if(_r?.code == 200) {
					let list =  Object.values(_r.data).sort( (a,b) => {
						return (new Date(b.ctime)).getTime() - (new Date(a.ctime)).getTime();
					})
					resolve(list)
				}else {
					resolve([])
				}
			} )
		})
	},

	///////////////////以下为旧接口/////////////////////////

    getSourceType( conf ){
        if( conf.type == 2 ){
            conf.sourceType = "folder";
            conf.typeName   = "目录";
        }else{
            let _extName    = conf.name.slice( conf.name.lastIndexOf( "." ) + 1 );
            switch ( _extName ){
                case "txt" : conf.sourceType = "txt"; conf.typeName   = "txt"; break;
                case "pdf" : conf.sourceType = "pdf"; conf.typeName   = "pdf"; break;
                case "json" : conf.sourceType = "json"; conf.typeName   = "json"; break;
                case "doc" : conf.sourceType = "doc"; conf.typeName   = "doc"; break;
                case "docx" : conf.sourceType = "doc"; conf.typeName   = "doc"; break;
                case "jpg" : conf.sourceType = "jpg"; conf.typeName   = "jpg"; break;
                case "png" : conf.sourceType = "png"; conf.typeName   = "png"; break;
                case "svg" : conf.sourceType = "svg"; conf.typeName   = "svg"; break;
                default : conf.sourceType = "unknow"; conf.typeName   = "未知"; break;
            }
        }
    },



    /**
     * 获取市场可用PBC列表
     */
    getPBCs( tags, response ){
        let _param  = tags.length > 0 ? { tags : tags } : {};
        return apiAxios.post( `${config.serverUrl}/cmss/v1/comp-service/user/pbc/list`, _param, response );
    },


    /**
     * 获取个人可用PBC列表
     * @param response
     */
    getUserPBCs( tags, response ){
        let _param  = tags.length > 0 ? { tags : tags } : {};
        return apiAxios.post( `${config.serverUrl}/cmss/v1/comp-service/user/pbc/myList`, _param, response );
    },

	/**
	 * 根据PBC路径获取PBC信息
	 * @param pbcPath
	 * @param response
	 */
	getPBCByPath( pbcPath, response ){
		let _param  = {
			"filter"	: `'fileInfo.fullName' eq '${pbcPath}'`
		};
		return apiAxios.post( `${config.serverUrl}/cmss/v1/comp-service/user/pbc/list`, _param, _r => {
			if( _r?.code == 200 && _r?.data?.total >= 1 ){
				response( _r.data.records[0] );
			}else{
				response( false );
			}
		} );
	},



	/**
	 * 获取市场可用PBC列表
	 */
	getRobots( tags, response ){
		let _param  = tags.length > 0 ? { tags : tags } : {};
		return apiAxios.post( `${config.serverUrl}/cmss/v1/comp-service/user/robot/list`, _param, response );
	},


	/**
	 * 获取个人可用PBC列表
	 * @param response
	 */
	getUserRobots( tags, response ){
		response();
		// let _param  = tags.length > 0 ? { tags : tags } : {};
		// return apiAxios.post( `${config.serverUrl}/cmss/v1/comp-service/user/pbc/myList`, _param, response );
	},

    /**
     * 获取可用机器人列表
     */
    getProjects( response ){
        return apiAxios.post( `${config.serverUrl}/cmss/v1/comp-service/user/project/list`, {}, response );
    },

    /**
     * 添加机器人文件机器人fileInfo路径
     * @param path
     * @param response
     */
     addPBCPath( path, response ){
        return apiAxios.patch( `${docServiceUrlV1}/info/${path}`, {
            "content" : [
                {
                    "op" : "add",
                    "path" : "/extends/pbcs",
                    "value": {}
                }
            ]
        }, response );
    },

    /**
     * 添加机器人
     * @param config
     * @param response
     */
    addPBC( path, PBCConf, response ){
        return apiAxios.patch( `${docServiceUrlV1}/info/${path}`, {
            "content" : [
                {
                    "op" : "add",
                    "path" : `/extends/pbcs/${PBCConf.id}`,
                    "value":PBCConf
                }
            ]
        }, response );
    },

    /**
     * 删除绑定的PBC
     * @param config
     * @param response
     */
    removePBC( path, pbcIds, response ){
    	let _command	= [];
    	pbcIds.forEach( _id => {
			_command.push( {
				"op" : "remove",
				"path" : `/extends/pbcs/${_id}`
			} )
		} )
        return apiAxios.patch( `${docServiceUrlV1}/info/${path}`, {
            "content" : _command
        }, response );
    },

    /**
     * 获取看板配置列表
     * @param tags
     * @param response
     * @returns {*}
     */
    getBoards( tags, response ){
        let _param  = tags.length > 0 ? { tags : tags } : {};
        return apiAxios.post( `${config.serverUrl}/cmss/v1/comp-service/netdisk/public/dir_list/kanbans/release`, _param, response );
    },

    /**
     * 获取看板配置
     * @param path
     */
    getBoardConf( path, response ){
        return apiAxios.get( `${config.serverUrl}/cmss/v1/comp-service/netdisk/public/file_download/${path}`, {}, response );
    },

    /**
     * 添加看板fileInfo路径
     * @param path
     * @param response
     */
    addBoardPath( path, response ){
        return apiAxios.patch( `${docServiceUrlV1}/info/${path}`, {
            "content" : [
                {
                    "op" : "add",
                    "path" : "/extends/kanbans",
                    "value": {}
                }
            ]
        }, response );
    },

    /**
     * 添加看板fileInfo
     * @param config
     * @param response
     */
    addBoard( path, boardConf, response ){
        return apiAxios.patch( `${docServiceUrlV1}/info/${path}`, {
            "content" : [
                {
                    "op" : "add",
                    "path" : `/extends/kanbans/${boardConf.id}`,
                    "value":boardConf
                }
            ]
        }, response );
    },

	/**
	 * 取消看板fileInfo
	 * @param config
	 * @param response
	 */
	removeBoard( path, boardConf, response ){
		return apiAxios.patch( `${docServiceUrlV1}/info/${path}`, {
			"content" : [
				{
					"op" : "remove",
					"path" : `/extends/kanbans/${boardConf.id}`
				}
			]
		}, response );
	},
	/**
	 * 添加机器人文件机器人fileInfo路径
	 * @param path
	 * @param response
	 */
	addRobotPath( path, response ){
		return apiAxios.patch( `${docServiceUrlV1}/info/${path}`, {
			"content" : [
				{
					"op" : "add",
					"path" : "/extends/robots",
					"value": {}
				}
			]
		}, response );
	},

	/**
	 * 添加机器人绑定
	 * @param config
	 * @param response
	 * 创建目录/extends/pbcs/idddd
	 */
	addRobot( path, conf, response ){
		return apiAxios.patch( `${docServiceUrlV1}/info/${path}`, {
			"content" : [
				{
					"op" : "add",
					"path" : `/extends/robots/${conf.id}`,
					"value":conf
				}
			]
		}, response );
	},

	/**
	 * 移除机器人绑定
	 * @param config
	 * @param response
	 * 创建目录/extends/pbcs/idddd
	 */
	removeRobot( path, conf, response ){
		return apiAxios.patch( `${docServiceUrlV1}/info/${path}`, {
			"content" : [
				{
					"op" : "remove",
					"path" : `/extends/robots/${conf.id}`,
					"value":conf
				}
			]
		}, response );
	},

    /**
     * 根据文件版本获取fileInfo信息
     * @param path
     * @param version
     * @returns {*}
     */
    getFileInfoByFileVersion( path, version ){
        return new Promise( (resolve, reject) => {
            apiAxios.get( `${docServiceUrlV1}/info/${path}?iv=${version}`, {}, _r => {
                if( _r.code == 200 && _r.data ){
                    resolve( _r.data );
                }else
                    reject();
            } );
        } )

    },

    getPBCTags( path, uid ){
        return new Promise( ( resolve, reject ) => {
            apiAxios.get( `${config.serverUrl}/cmss/v1/comp-service/backend/resource/tag/${path}?sourceUserId=${uid}&opUserId=${uid}`, {}, _r => {
                if( _r?.code == 200 )
                    resolve( _r.data );
                else
                    reject();
            } )
        } )
    },

	/**
	 * 生成分享链接
	 */
	creatSharedLink(path) {
		return new Promise( ( resolve, reject ) => {
			let _r = {
				code: '200',
				msg: '',
				data: `https://cmdptest.cmdp.cn/user/docs/${path}`
			}
			if( _r?.code == 200 )
			    resolve( _r.data );
			else
			    reject();
		} )
	},
	/**
     * 获取公共文件列表
     * @param tags
     * @param response
     * @returns {*}
     */
    getPublicList(path, params, response ){
        return apiAxios.post( `${config.serverUrl}/cmss/v1/comp-service/netdisk/public/dir_list/${path}`, params, response );
    },
}
